import React from 'react';
import { Checkbox, Divider, Grid, InputAdornment, MenuItem, Stack, Typography } from '@mui/material';
import flightStyles from '../flightsfolder.module.css';
import styles from 'custom/style.module.css';
import { BorderLinearProgress, CustomCheckbox, CustomDateTimePicker, CustomInputLabel, CustomSelect, CustomTextField, FlexDiv, InputProps, SelectInputProps, StyledCard, StyledCardTitle } from 'custom/components';
import moment from 'moment-timezone';
import Countdown from 'react-countdown';
import { getStationUTC, getStationDate, getStationDateTime } from 'utils/converter';
import { Search } from '@mui/icons-material';
import cookies from 'utils/cookies';
import dayjs from 'dayjs';
import { EditIcon, platforms } from 'custom/constants';
import History from '../History';
import NoOpRemarkModal from './NoOpRemark';


const getpercentage = (date1, date2) => {
  let total = moment(date2).diff(date1, 'minutes');
  let current = moment(moment().utc().format('YYYY-MM-DD HH:mm:ss')).diff(date1, 'minutes');
  if (current < 0) {
    return 0;
  } else {
    if (current >= total) return 100;
    let rem = Math.round((current / total) * 100);
    return rem;
  }
};
const getCountdown = (date) => {
  // formate
  let dateUTC = moment.utc(date).local().format('YYYY-MM-DDTHH:mm:ss');
  return new Date(dateUTC);
};

const renderer = ({ hours, minutes, completed }) => {
  if (completed) {
    // Render a completed state
    return '00:00';
  } else {
    // Render a countdown
    return <span>{String(hours).padStart(2, '0')}:{String(minutes).padStart(2, '0')}</span>;
  }
};


const FlightsInfo = (props) => {
  const getGate = (type = 'data', data) => {
    const stn = cookies.get('station_code');
    if (type === 'data') {
      let gate = data?.org === stn ? data?.dept_gate : data?.arr_gate;
      if (props.printFunction) {
        props.printFunction(gate, 'flight_gate');
      }
      return gate;
    } else {
      return data?.org === stn ? 'dept_gate' : 'arr_gate';
    }
  };
  return (
    <>
      <StyledCard className={`${styles.mb4} ${!props.showFlight ? styles.pb0 : ''}`}>
        <Stack direction='row' justifyContent='space-between' alignItems='center' width='100%'>
          <FlexDiv className={styles.mb2}>
            <Stack direction='row' alignItems='center'>
              <StyledCardTitle gutterBottom className={flightStyles.flightInfoTitle}>
                <Checkbox inputProps={{ 'aria-label': 'flight-info', }} checked={props.showFlight} onChange={e => props.changeCheck(e)} name='view_info'
                  sx={{
                    padding: '0px',
                    marginRight: '10px',
                    '& .MuiSvgIcon-root': { fontSize: 16 }
                  }}
                />
              Flight Info 
              </StyledCardTitle>
              <Stack direction='row' alignItems='center' spacing={1} mt={'-20px'}>
                <Divider orientation='vertical' flexItem sx={{
                  margin: '0 10px',
                  backgroundColor: '#ffffff8f',
                  height: '20px', 
                }} />
                <History
                  id={props.flightData?.id}
                />
              </Stack> 
            </Stack>
          </FlexDiv>
          <CustomCheckbox
            ref={props.noOpCheckboxRef}
            control={
              <Checkbox
                name='no_op_flight'
                color='primary'
                inputProps={{ 'aria-label': 'no-op flight' }}
                className={`${styles.py0} ${styles.pl0}`}
                checked={props.isNoOp}
                // onChange={props.handleNoOpChange}
                onChange={props.handleNoOpClick}
                disabled={props.disableNoOp || cookies.get('role') === 'Airline Rep'}
              />}
            className={`${styles.mr0} ${styles.pb1}`}
            sx={{ mt: '-24px' }}
            label='Mark flight as no-ops'
            labelPlacement='end' />
        </Stack>
        <div className={`${flightStyles.container} ${props.showFlight ? flightStyles.open : ''}`}>
          <Grid container spacing={2} alignItems='center' >
            <Grid item xs={12} sm={6} md={2.4} lg={1.5} xl={1.5} minWidth={'170px'}>
              <CustomInputLabel htmlFor='flight_no' aria-label='Enter Flight Number' className={styles.fSpaceBtw}>
                <span>Flight Number</span>
                {!props.showReportModal &&
              <Search fontSize='inherit' onClick={() => props.onEditField('flight_no')} />
                }
              </CustomInputLabel>
              {!props.showReportModal && props?.editField === 'flight_no' ? (
                <CustomTextField
                  {...InputProps}
                  id='flight_no'
                  fullWidth
                  autoFocus
                  type='text'
                  // value={props.search}
                  onChange={props.onchangeSearch}
                  onBlur={props.handleSearch}
                  defaultValue={props?.flightData?.flight_no ? props?.flightData?.airline?.code + props?.flightData?.flight_no + '/' + moment(props?.flightData?.flight_date).format('DDMMMYY').toUpperCase() : ''}
                  InputProps={{
                    classes: { input: styles.pr0 }, 
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position='end' >
                        <Search onClick={props.handleSearch} fontSize='inherit' />
                      </InputAdornment>
                    ),
                  }}
                  onKeyDown={
                    (e) => {
                      if (e.key === 'Enter') {
                        props.handleSearch();
                      }
                    }
                  }
                />) : (
                <span className={flightStyles.fields} 
                  onClick={() => props.onEditField('flight_no')}>
                  {props?.flightData?.flight_no ? props?.flightData?.airline?.code + props?.flightData?.flight_no + '/' + moment(props?.flightData?.flight_date).format('DDMMMYY').toUpperCase() : ''}
                </span>
              )}
                
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={1.5} xl={1.5} minWidth={'145px'} >
              <CustomInputLabel htmlFor='reg_no' aria-label='Enter registration' className={styles.fSpaceBtw}>
                <span>Department</span>
                {!props.showReportModal &&
              <Search fontSize='inherit' onClick={() => props.onEditField('contract_types')} />
                }
              </CustomInputLabel>
              <div>
                {!props.showReportModal && props?.editField === 'contract_types' ? (
                  <CustomSelect
                    fullWidth
                    id='contract_types'
                    name='contract_types'
                    label={false}
                    value={props.ctype}
                    onChange={props.onSelect}
                    // onBlur={props.onSelect}
                    className={`${styles.minWidth200} ${styles.fOne}`}
                  >
                    {/* {
                    cookies.get('contract_types')?.map((type, index) => (
                      <MenuItem key={index} value={type}>{type}</MenuItem>
                    ))
                  } */}
                    {
                      props.contractTypes.map((contractType, index) => (
                        <MenuItem key={index} value={contractType}>{contractType}</MenuItem>
                      ))
                    }
                  </CustomSelect>) : (
                  <span className={flightStyles.fields} onClick={() => props.onEditField('contract_types')}>
                    {props.ctype}</span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={1} xl={1} minWidth={'100px'}>
              <CustomInputLabel htmlFor='ac_Type' aria-label='Enter ac type' className={styles.fSpaceBtw}>
                <span>AC Type </span>
                {!props.showReportModal &&
                  <EditIcon className={`${styles.smActionIcons} ${styles.p0} ${styles.fs0}`} onClick={() => props.onEditField('ac_type')} disabled={cookies.get('role') === 'Airline Rep'} />
                }
              </CustomInputLabel>
              <div>
                {!props.showReportModal && props?.editField === 'ac_type' ? (
                  <CustomTextField
                    {...InputProps}
                    id='ac_type'
                    fullWidth
                    autoFocus
                    type='text'
                    defaultValue={props?.flightData?.ac_type}
                    onBlur={e => props.onChange('ac_type', props?.flightData?.ac_type, e.target.value)}
                  />) : (
                  <span className={flightStyles.fields} onClick={() => props.onEditField('ac_type')}>{props?.flightData?.ac_type}</span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={1} xl={1}  minWidth={'110px'} >
              <CustomInputLabel htmlFor='reg_no' aria-label='Enter registration' className={styles.fSpaceBtw}>
                <span>Registration</span>
                {!props.showReportModal &&
                  <EditIcon className={`${styles.smActionIcons} ${styles.p0} ${styles.fs0}`} onClick={() => props.onEditField('reg_no')} disabled={cookies.get('role') === 'Airline Rep'} />
                }
              </CustomInputLabel>
              <div>
                {!props.showReportModal && props?.editField === 'reg_no' ? (
                  <CustomTextField
                    {...InputProps}
                    id='reg_no'
                    fullWidth
                    autoFocus
                    type='text'
                    defaultValue={props?.flightData?.reg_no}
                    onBlur={e => props.onChange('reg_no', props?.flightData?.reg_no, e.target.value)}
                  />) : (
                  <span className={flightStyles.fields} onClick={() => props.onEditField('reg_no')}>{props?.flightData?.reg_no}</span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={1} xl={1} minWidth={'110px'}>
              <CustomInputLabel htmlFor='platform-label' aria-label='Enter platform' className={styles.fSpaceBtw}>
                <span>Platform</span>
                {!props.showReportModal &&
                  <EditIcon className={`${styles.smActionIcons} ${styles.p0} ${styles.fs0}`} onClick={() => props.onEditField('platform')} disabled={cookies.get('role') === 'Airline Rep'} />
                }
              </CustomInputLabel>
              <CustomSelect
                {...SelectInputProps}
                id='platform'
                labelId='platform-label'
                name='platform'
                fullWidth
                disabled={props.flightData?.platform && props.editField !== 'platform'}
                value={props.flightData?.platform?.toUpperCase() || ''}
                onChange={(e) => props.onChange('platform', props.flightData?.platform, e.target.value)}
                error={!props.flightData?.platform}
                classes={{
                  select: flightStyles.selectField,
                  disabled: flightStyles.disabledSelectField
                }}
              >
                <MenuItem value='placeholder' disabled>Select a Platform</MenuItem>
                {platforms.map((name) => (
                  <MenuItem key={name} value={name?.toUpperCase()}>
                    {name}
                  </MenuItem>
                ))}
              </CustomSelect> 
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={1} xl={1} minWidth={'90px'}>
              <CustomInputLabel htmlFor='routing' aria-label='Enter Routing'>Routing</CustomInputLabel>
              <CustomTextField
                {...InputProps}
                id='routing'
                fullWidth
                autoFocus
                type='text'
                value={props?.flightData?.org ? props?.flightData?.org + '-' + props?.flightData?.dest : ''}
                disabled
                InputProps={{ classes: { input: flightStyles.ipField, }, }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={1.5} xl={1.5} minWidth={'170px'}>
              <CustomInputLabel htmlFor='Departure' aria-label='Enter Departure' className={styles.fSpaceBtw}>
                <span>Departure</span>
                {!props.showReportModal &&
                  <EditIcon className={`${styles.smActionIcons} ${styles.p0} ${styles.fs0}`} onClick={() => props.onEditField('act_dept')} disabled={cookies.get('role') === 'Airline Rep'} />
                }
              </CustomInputLabel>
              {!props.showReportModal && props?.editField === 'act_dept' ? (
                <CustomDateTimePicker
                  slotProps={{
                    textField: {
                      ...InputProps,
                      placeholder: 'Actual Departure',
                      fullWidth: true
                    },
                  }}
                  format={'DD MMM YY HH:mm'}
                  className={`${styles.w100} ${styles.minWidth125}`}
                  ampm={false}
                  timeSteps={{
                    hours: 1,
                    minutes: 1,
                  }}
                  onClose={() => props.onEditField('')}
                  onAccept={(v) => props.onChange('act_dept', props?.flightData?.act_dept, getStationUTC(props?.flightData?.org, moment(v.$d).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'))}
                  value={dayjs(props?.flightData?.act_dept ? getStationDateTime(props?.flightData?.org, props?.flightData?.act_dept) : (props?.flightData?.est_dept ? getStationDateTime(props?.flightData?.org, props?.flightData?.est_dept) : (props?.flightData?.schdl_dept ? getStationDateTime(props?.flightData?.org, props?.flightData?.schdl_dept) : null)))}
                />) : (
                <Stack direction='row' alignItems='center' spacing={1} onClick={() => props.onEditField('act_dept')}>
                  <span className={flightStyles.fields}>{props?.flightData?.act_dept ? getStationDate(props?.flightData?.org, props?.flightData?.act_dept, 'DDMMMYY HHmm') : (props?.flightData?.est_dept ? getStationDate(props?.flightData?.org, props?.flightData?.est_dept, 'DDMMMYY HHmm') : (props?.flightData?.schdl_dept ? getStationDate(props?.flightData?.org, props?.flightData?.schdl_dept, 'DDMMMYY HHmm') : null))}</span>
                  <span className={flightStyles.inlineEl}>{props?.flightData?.act_dept ? 'A' : (props?.flightData?.est_dept ? 'E' : 'S')}</span>
                </Stack>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={1.5} xl={1.5} minWidth={'170px'}>
              <CustomInputLabel htmlFor='arrival' aria-label='Enter Arrival' className={styles.fSpaceBtw}>
                <span>Arrival</span>
                {!props.showReportModal &&
                  <EditIcon className={`${styles.smActionIcons} ${styles.p0} ${styles.fs0}`} onClick={() => props.onEditField('act_arr')} disabled={cookies.get('role') === 'Airline Rep'} />
                }
              </CustomInputLabel>
              {!props.showReportModal && props?.editField === 'act_arr' ? (
                <CustomDateTimePicker
                  slotProps={{
                    textField: {
                      ...InputProps,
                      placeholder: 'Actual Arrival',
                      fullWidth: true
                    },
                  }}
                  format={'DD MMM YY HH:mm'}
                  className={`${styles.w100} ${styles.minWidth125}`}
                  ampm={false}
                  timeSteps={{
                    hours: 1,
                    minutes: 1,
                  }}
                  onClose={() => props.onEditField('')}
                  onAccept={(v) => props.onChange('act_arr', props?.flightData?.act_arr, getStationUTC(props?.flightData?.dest, moment(v.$d).format('YYYY-MM-DD HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss'))}
                  value={dayjs(props?.flightData?.act_arr ? getStationDateTime(props?.flightData?.dest, props?.flightData?.act_arr) : (props?.flightData?.est_arr ? getStationDateTime(props?.flightData?.dest, props?.flightData?.est_arr) : (props?.flightData?.schdl_arr ? getStationDateTime(props?.flightData?.dest, props?.flightData?.schdl_arr) : null)))}
                />) : (
                <Stack direction='row' alignItems='center' spacing={1} onClick={() => props.onEditField('act_arr')}>
                  <span className={flightStyles.fields}>{props?.flightData?.act_arr ? getStationDate(props?.flightData?.dest, props?.flightData?.act_arr, 'DDMMMYY HHmm') : (props?.flightData?.est_arr ? getStationDate(props?.flightData?.dest, props?.flightData?.est_arr, 'DDMMMYY HHmm') : (props?.flightData?.schdl_arr ? getStationDate(props?.flightData?.dest, props?.flightData?.schdl_arr, 'DDMMMYY HHmm') : null))}</span>
                  <span className={flightStyles.inlineEl}>{props?.flightData?.act_arr ? 'A' : (props?.flightData?.est_arr ? 'E' : 'S')}</span>
                </Stack>
              )}
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg xl minWidth={'90px'} >
              <CustomInputLabel htmlFor='gate' aria-label='Enter gate' className={styles.fSpaceBtw}>
                <span>Gate</span>
                {!props.showReportModal &&
                  <EditIcon className={`${styles.smActionIcons} ${styles.p0} ${styles.fs0}`} onClick={() => props.onEditField('gate')} disabled={cookies.get('role') === 'Airline Rep'} />
                }
              </CustomInputLabel>
              <div>
                {!props.showReportModal && props?.editField === 'gate' ? (
                  <CustomTextField
                    {...InputProps}
                    id='gate'
                    fullWidth
                    autoFocus
                    type='text'
                    defaultValue={getGate('data', props?.flightData)}
                    onBlur={e => props.onChange(getGate('key', props?.flightData), getGate('data', props?.flightData), e.target.value)}
                  />) : (
                  <span className={flightStyles.fields} onClick={() => props.onEditField('gate')}>{getGate('data', props?.flightData)} </span>
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg='auto' xl='auto' className={styles.mt2} minWidth={'150px'} maxWidth={'250px'}>
              <div className={flightStyles.progressWrapper}>
                <BorderLinearProgress variant='determinate' value={getpercentage(props?.flightData?.act_dept || props?.flightData?.est_dept || props?.flightData?.schdl_dept, props?.flightData?.act_arr || props?.flightData?.est_arr || props?.flightData?.schdl_arr)} className={styles.w100} /> 
                <Typography variant='caption' ml={'-10px'}>
                  <Countdown date={getCountdown(props?.flightData?.act_arr || props?.flightData?.est_arr || props?.flightData?.schdl_arr)} startTime={getCountdown(props?.flightData?.act_dept || props?.flightData?.est_dept || props?.flightData?.schdl_dept)} renderer={renderer} />
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        {!props.showFlight ?
          <Typography variant='caption' color={'text.secondary'} component={'div'} className={styles.textSecondary} textAlign={'center'} fontStyle={'italic'} mt={-4.5} pb={1.5}>
            Flight information is hidden. Check the box to view the details.
          </Typography> : ''}
      </StyledCard>

      {props.showNoOpPopup && (
        <NoOpRemarkModal
          popup={props.showNoOpPopup}
          anchorEl={props.noOpCheckboxRef.current}
          remark={props.noOpReason}
          onChange={props.handleNoOpReasonChange}
          handleOk={props.handleNoOpOk}
          handleClose={props.handleNoOpCancel}
        />
      )}
    </>
  );
};

export default FlightsInfo;